export const StorageNoop: Storage = {
  length: 0,
  clear: () => {},
  getItem: (key: string) => null,
  key: (index: number) => null,
  removeItem: (key: string) => {},
  setItem: (key: string, value: string) => {},
};
